/* Sélecteur « Trouvez votre pièce » : Marque -> Modèle -> Type de pièce.
   Données : snippets/lpa-vehicle-data.liquid (généré depuis les tags produits).
   Le modèle filtre par tag (filter.p.tag) car une pièce de C3 peut être rangée sous la marque Peugeot. */
(function () {
  'use strict';

  var STORAGE_KEY = 'lpa-vehicle';

  /* La liste Marque -> Modèles est construite en direct à partir de TOUS les tags de la boutique
     (collections.all.all_tags, rendu par lpa-hero) : un nouveau modèle apparaît dès qu'un produit porte son tag.
     snippets/lpa-vehicle-data.liquid ne sert plus qu'à départager les tags en double (ex. « Audi a3 » / « audi a3 ») :
     on garde la variante la plus utilisée, car les filtres de tags Shopify sont sensibles à la casse. */
  var BRANDS = [
    ['Peugeot', ['peugeot']], ['Renault', ['renault']], ['Citroën', ['citroen', 'citroën']], ['Volkswagen', ['vw', 'volkswagen']],
    ['Audi', ['audi']], ['Dacia', ['dacia']], ['BMW', ['bmw']], ['Mercedes', ['mercedes']], ['Skoda', ['skoda']], ['Seat', ['seat']],
    ['Nissan', ['nissan']], ['Ford', ['ford']], ['Toyota', ['toyota']], ['Opel', ['opel']], ['Tesla', ['tesla']], ['Fiat', ['fiat']],
    ['Mini', ['mini']], ['Kia', ['kia']], ['Alfa Romeo', ['alfa romeo']], ['Suzuki', ['suzuki']], ['Land Rover', ['land rover']],
    ['Hyundai', ['hyundai']], ['Honda', ['honda']], ['Volvo', ['volvo']], ['Porsche', ['porsche']], ['Jaguar', ['jaguar']],
    ['MG', ['mg']], ['Smart', ['smart']], ['DS', ['ds']], ['Jeep', ['jeep']], ['Lexus', ['lexus']], ['Mazda', ['mazda']],
    ['Mitsubishi', ['mitsubishi']], ['Subaru', ['subaru']], ['Chevrolet', ['chevrolet']], ['Cupra', ['cupra']], ['Lancia', ['lancia']]
  ];
  var VENDOR = { BMW: 'Bmw' };
  var FIX = { modele: 'model', 'x-trial': 'x-trail', moka: 'mokka', mikka: 'mokka', 'new bettle': 'new beetle', loggy: 'lodgy', cmax: 'c-max', 'rav 4': 'rav4', raftcat: null, not: null };
  var UPPER = /^(ds\d|id\d|[a-z]{1,2}\d+|\d+|tt|zs|xj|gl[a-z]|cl[a-z]|eq[a-z]|e\d+|g\d+|m\d|i\d|c\d+|q\d|x\d|v\d+)$/;

  function label(m) {
    return m.split(' ').map(function (w) {
      return UPPER.test(w) ? w.toUpperCase() : w.replace(/(^|-)([a-z])/g, function (_, a, b) { return a + b.toUpperCase(); });
    }).join(' ')
      .replace('ID3', 'ID.3').replace('ID4', 'ID.4').replace('I8', 'i8')
      .replace('E-Tron', 'e-tron').replace('C-Hr', 'C-HR').replace('Rav4', 'RAV4').replace('Traffic', 'Trafic')
      .replace(/^(3008|5008) 2$/, '$1 II');
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function readData() {
    var preferred = {};
    (readJSON('lpa-vehicle-data') || []).forEach(function (b) {
      b.m.forEach(function (m) { preferred[b.b + '|' + m.l] = m.t; });
    });
    var tags = readJSON('lpa-all-tags');
    if (!tags || !tags.length) return readJSON('lpa-vehicle-data') || [];

    return BRANDS.map(function (cfg) {
      var brand = cfg[0], prefixes = cfg[1], groups = {};
      tags.forEach(function (tag) {
        var t = String(tag).trim().toLowerCase();
        var p = prefixes.find(function (x) { return t.indexOf(x + ' ') === 0; });
        if (!p) return;
        var model = t.slice(p.length).trim();
        Object.keys(FIX).some(function (bad) {
          if (model === bad || model.indexOf(bad + ' ') === 0 || model.slice(-bad.length - 1) === ' ' + bad) {
            model = FIX[bad] === null ? '' : model.replace(bad, FIX[bad]);
            return true;
          }
          return false;
        });
        if (!model) return;
        (groups[model] = groups[model] || []).push(tag);
      });
      var models = Object.keys(groups).sort(function (a, b) { return a.localeCompare(b, 'fr', { numeric: true }); }).map(function (k) {
        var l = label(k);
        var pref = preferred[brand + '|' + l];
        return { l: l, t: groups[k].indexOf(pref) > -1 ? pref : groups[k][0] };
      });
      return { b: brand, v: VENDOR[brand] || brand, m: models };
    }).filter(function (b) { return b.m.length || (readJSON('lpa-vehicle-data') || []).some(function (x) { return x.b === b.b; }); });
  }

  function remember(value) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (e) { /* stockage indisponible */ }
  }

  function recall() {
    try { return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null'); } catch (e) { return null; }
  }

  function option(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function init(root) {
    if (root.dataset.lpaReady) return;
    root.dataset.lpaReady = '1';

    var data = readData();
    var form = root.querySelector('[data-lpa-finder-vehicle]');
    var brandSel = root.querySelector('[data-lpa-brand]');
    var modelSel = root.querySelector('[data-lpa-model]');
    var catSel = root.querySelector('[data-lpa-cat]');
    if (!form || !brandSel || !modelSel) return;

    data.forEach(function (b, i) { brandSel.appendChild(option(String(i), b.b)); });

    function markDone() {
      [brandSel, modelSel, catSel].forEach(function (sel) {
        if (!sel) return;
        var field = sel.closest('[data-step]');
        if (field) field.classList.toggle('is-done', !!sel.value);
      });
    }

    function fillModels(brandIndex, selectedLabel) {
      modelSel.innerHTML = '';
      modelSel.appendChild(option('', 'Choisir le modèle'));
      var brand = data[brandIndex];
      if (!brand || !brand.m.length) {
        modelSel.disabled = true;
        if (brand) modelSel.options[0].textContent = 'Tous les modèles';
        return;
      }
      brand.m.forEach(function (m, i) {
        var o = option(String(i), m.l);
        if (selectedLabel && m.l === selectedLabel) o.selected = true;
        modelSel.appendChild(o);
      });
      modelSel.disabled = false;
    }

    brandSel.addEventListener('change', function () {
      fillModels(brandSel.value);
      markDone();
      if (brandSel.value && !modelSel.disabled) modelSel.focus();
    });
    modelSel.addEventListener('change', markDone);
    if (catSel) catSel.addEventListener('change', markDone);

    /* Véhicule mémorisé lors d'une visite précédente */
    var saved = recall();
    if (saved && saved.b) {
      var idx = data.findIndex(function (b) { return b.b === saved.b; });
      if (idx > -1) {
        brandSel.value = String(idx);
        fillModels(idx, saved.m);
        markDone();
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var brand = data[brandSel.value];
      if (!brand) {
        brandSel.focus();
        brandSel.closest('[data-step]').classList.add('is-error');
        return;
      }
      var model = brand.m[modelSel.value];
      var category = catSel && catSel.value;
      var url;

      /* Les filtres de tags se combinent en ET : un seul tag (celui du modèle) par recherche. */
      if (model) {
        url = new URL(category || form.getAttribute('action') || '/collections/all', window.location.origin);
        url.searchParams.set('filter.p.tag', model.t);
      } else if (category) {
        url = new URL(category, window.location.origin);
        url.searchParams.set('filter.p.vendor', brand.v);
      } else {
        /* Marque seule : la recherche couvre aussi les pièces partagées entre marques (ex. Peugeot/Citroën). */
        url = new URL('/search', window.location.origin);
        url.searchParams.set('q', brand.b.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase());
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
      }

      remember({ b: brand.b, m: model ? model.l : '' });
      window.location.href = url.pathname + url.search;
    });

    /* Onglets Véhicule / Référence */
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        var first = panel && panel.querySelector('input[type="search"], select');
        if (first) first.focus();
      });
    });

    /* Suggestions de recherche */
    root.querySelectorAll('[data-lpa-example]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('form').querySelector('input[type="search"]');
        input.value = btn.getAttribute('data-lpa-example');
        btn.closest('form').submit();
      });
    });
  }

  /* Barre « Filtrer par véhicule » des pages collection : filtre la collection courante par tag de modèle */
  function initBar(form) {
    if (form.dataset.lpaReady) return;
    form.dataset.lpaReady = '1';
    var data = readData().filter(function (b) { return b.m.length; });
    var brandSel = form.querySelector('[data-lpa-vbar-brand]');
    var modelSel = form.querySelector('[data-lpa-vbar-model]');
    var reset = form.querySelector('[data-lpa-vbar-reset]');
    if (!data.length) { form.hidden = true; return; }

    data.forEach(function (b, i) { brandSel.appendChild(option(String(i), b.b)); });

    function fill(i, selectedTag) {
      modelSel.innerHTML = '';
      modelSel.appendChild(option('', 'Tous les modèles'));
      var b = data[i];
      if (!b) { modelSel.disabled = true; return; }
      b.m.forEach(function (m, j) {
        var o = option(String(j), m.l);
        if (selectedTag && m.t === selectedTag) o.selected = true;
        modelSel.appendChild(o);
      });
      modelSel.disabled = false;
    }

    /* Filtre déjà actif dans l'URL ? */
    var params = new URLSearchParams(window.location.search);
    var activeTag = params.get('filter.p.tag');
    var activeVendor = params.get('filter.p.vendor');
    var found = false;
    data.forEach(function (b, i) {
      if (found) return;
      var m = activeTag && b.m.find(function (x) { return x.t === activeTag; });
      if (m || (activeVendor && b.v === activeVendor && !activeTag)) {
        brandSel.value = String(i);
        fill(i, m && m.t);
        found = true;
        if (reset) {
          reset.hidden = false;
          reset.querySelector('[data-lpa-vbar-current]').textContent = b.b + (m ? ' ' + m.l : '');
          var clean = new URLSearchParams(window.location.search);
          clean.delete('filter.p.tag'); clean.delete('filter.p.vendor'); clean.delete('page');
          reset.href = window.location.pathname + (clean.toString() ? '?' + clean.toString() : '');
        }
      }
    });
    if (!found) {
      var saved = recall();
      if (saved && saved.b) {
        var idx = data.findIndex(function (b) { return b.b === saved.b; });
        if (idx > -1) {
          brandSel.value = String(idx);
          fill(idx);
          var mi = data[idx].m.findIndex(function (m) { return m.l === saved.m; });
          if (mi > -1) modelSel.value = String(mi);
        }
      }
    }

    brandSel.addEventListener('change', function () { fill(brandSel.value); if (!modelSel.disabled) modelSel.focus(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var b = data[brandSel.value];
      if (!b) { brandSel.focus(); return; }
      var m = b.m[modelSel.value];
      var q = new URLSearchParams(window.location.search);
      q.delete('filter.p.tag'); q.delete('filter.p.vendor'); q.delete('page');
      if (m) q.append('filter.p.tag', m.t); else q.append('filter.p.vendor', b.v);
      remember({ b: b.b, m: m ? m.l : '' });
      window.location.href = window.location.pathname + '?' + q.toString();
    });
  }

  function boot() {
    document.querySelectorAll('[data-lpa-vehicle-bar]').forEach(initBar);
    document.querySelectorAll('[data-lpa-finder]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
